/* import __COLOCATED_TEMPLATE__ from './empty-state.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./empty-state.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));